import React, {Component} from 'react';
import {Mutation, Query} from 'react-apollo';
import PropTypes from 'prop-types';
import ISNResultQuery from '../../../Queries/ISNResultQuery';
import QCResult from './QCResult';
import SetPaxSelectedISNResult from '../../../Mutations/SetPaxSelectedISNResult';
import {Alert, message, Spin} from 'antd';
import LoadingContent from '../../LoadingContent';
import WithOrgData from '../../WithOrgData';
import {withUserGroups} from '../../userGroup';

class QCResultWithData extends Component {

    constructor() {
        super();
        this.state = {
            isActivating: false
        }
    }

    setActivating = (isActivating) => {
        this.setState({ isActivating });
    }

    render() {
        const { paxId, fetchPolicy, showISNCheck=true, orgData, userGroups, onResultUpdated, ...restProps } = this.props;
        return (
            <Query
                query={ISNResultQuery}
                variables={{
                    _id: paxId
                }}
                fetchPolicy={fetchPolicy || 'network-only'}
                errorPolicy="all"
            >
            {({ data, loading, error }) => {
                const passenger = data && data.getPassenger;
                if (!passenger && loading ) return <LoadingContent />
                const isnData = passenger && passenger.lastComplianceEngineResult?.isnProviderResult?._isnResult;
                const renderQCResult = () => (
                    <Spin spinning={loading}>
                        {error ? (
                            <Alert type="error" showIcon message="Failed to load ISN Data" />
                        ) : null}
                        <Mutation
                            mutation={SetPaxSelectedISNResult}
                        >
                        {
                            (setActive) => (
                                <QCResult
                                    data={isnData}
                                    isActivating={this.state.isActivating}
                                    onResultActivated={(data) => {
                                        const payload = {
                                            allowed: data.allowed,
                                            assignedActivities: data.assignedActivities,
                                            companyID: data.companyID,
                                            companyName: data.companyName,
                                            dataAsOf: data.dataAsOf,
                                            errorMessage: data.errorMessage,
                                            firstName: data.firstName,
                                            isnId: data.isnId,
                                            lastName: data.lastName,
                                            mostRecentTrainingExpirationDate: data.mostRecentTrainingExpirationDate,
                                            mostRecentTrainingQualificationExpirationName: data.mostRecentTrainingQualificationExpirationName,
                                            quickCheckStatus: data.quickCheckStatus,
                                            reason: data.reason,
                                            trainingStatus: data.trainingStatus
                                        }

                                        const hideMsg = message.loading("Updating selected result & re-running compliance check...", 0);

                                        this.setActivating(true);

                                        setActive({
                                            variables: {
                                                _id: passenger._id,
                                                _rev: passenger._rev,
                                                payload: JSON.stringify(payload)
                                            },
                                            optimisticResponse: {
                                                __typename: 'Mutation',
                                                setIsnSelection: {
                                                    __typename: 'PaxNode',
                                                    ...passenger,
                                                    _id: passenger._id,
                                                    lastComplianceEngineResult: {
                                                        ...passenger.lastComplianceEngineResult,
                                                        __typename: 'ComplianceEngineResult',
                                                        isnProviderResult: {
                                                            ...passenger.lastComplianceEngineResult.isnProviderResult,
                                                            __typename: 'ComplianceProviderResult',
                                                            _isnResult: {
                                                                ...isnData,
                                                                selectedResult: {
                                                                    __typename: 'IsnQcResult',
                                                                    ...payload
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        })
                                        .then(() => {
                                            message.success('Successfully updated selected ISN result');
                                            hideMsg();
                                            onResultUpdated?.();
                                            this.setActivating(false);
                                        })
                                        .catch((err) => {
                                            console.error(err);
                                            message.error('Failed to update selected ISN result');
                                            hideMsg();
                                            this.setActivating(false);
                                        })
                                    }}
                                    {...restProps}
                                />
                            )
                        }
                        </Mutation>
                    </Spin>
                );
                return renderQCResult();
            }}
            </Query>
        );
    }
}

QCResultWithData.propTypes = {
    paxId: PropTypes.string.isRequired,
    fetchPolicy: PropTypes.string,
    showISNCheck: PropTypes.bool
}
 
export default WithOrgData( withUserGroups( QCResultWithData) );